import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';
import { useNavigate } from 'react-router';
import { Translate } from 'react-redux-i18n';

import Loading from '../../components/Loading/Loading';
import auth from '../../auth';
import { validate as validateTokenAction } from '../ValidateToken/ValidateTokenActions';
import style from './Home.module.css';

function Home(props) {
  const { loading, validateToken } = props;
  const navigate = useNavigate();
  const [globalMessage, setGlobalMessage] = useState("");
  
  useEffect(() => {
    // Check authentication and redirect if not logged in
    if (!auth.loggedIn()) {
      navigate('/login');
      return;
    }

    validateToken().catch(() => navigate('/login'));
    getGlobalMessage();
  }, [validateToken, navigate]);

  async function getGlobalMessage() {
    try {
      const response = await axios.get('/api/global-message');
      if (response.data) {
        setGlobalMessage(response.data);
      }
    } catch (err) {
      console.error(err);
    }
  }

  function goto(route) {
    navigate(`/${route}`);
  }

  const user = auth.getUser();
  // Ensure user exists before accessing properties to avoid errors during redirect
  if (!user) return null;

  const isShared = user.level === 'shared';

  return (
    <div className="row">
      <div className="col-md-8 offset-md-1">
        { loading && <Loading /> }
        {
          globalMessage &&
          <div style={{background: "#ffc235", padding: 20}}>
            <h3 style={{textAlign: "center", color: "#333", fontWeight: "bold"}}>{globalMessage}</h3>
          </div>
        }
        <h3><strong><Translate value="home.title"/></strong></h3>
        <hr />
        <p><Translate value="home.text" dangerousHTML />
        </p>
        <div className={`row ${style.sections}`}>
          {!isShared &&
            <div className="col-xs-8 col-xs-offset-2 col-sm-6 col-sm-offset-0 col-md-3">
              <div
                className={style.section}
                onClick={() => goto('exercises')}
              >
                <div className={style.sectionIcon}>
                  <i className="fas fa-sitemap" />
                </div>
                <div className={style.sectionLabel}>
                  <Translate value="common.Exercises"/>
                </div>
              </div>
           </div>
          }
          <div className="col-xs-8 col-xs-offset-2 col-sm-6 col-sm-offset-0 col-md-3">
            <div
              className={style.section}
              onClick={() => goto('scenarios')}
            >
              <div className={style.sectionIcon}>
                <i className="fas fa-map" />
              </div>
              <div className={style.sectionLabel}>
                <Translate value="common.Scenarios"/>
              </div>
            </div>
          </div>
          {!isShared &&
            <div className="col-xs-8 col-xs-offset-2 col-sm-6 col-sm-offset-0 col-md-3">
              <div
                className={style.section}
                onClick={() => goto(`user/${user.id}`)}
              >
                <div className={style.sectionIcon}>
                  <i className="fas fa-user-circle" />
                </div>
                <div className={style.sectionLabel}>
                  <Translate value="auth.Account"/>
                </div>
              </div>
            </div>
          }
          <div className="col-xs-8 col-xs-offset-2 col-sm-6 col-sm-offset-0 col-md-3">
            <div
              className={style.section}
              onClick={() => goto('help')}
            >
              <div className={style.sectionIcon}>
                <i className="fas fa-question" />
              </div>
              <div className={style.sectionLabel}>
                <Translate value="common.Help"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

Home.propTypes = {
  loading: PropTypes.bool,
  validateToken: PropTypes.func,
};

const mapStateToProps = state => ({
  loading: state.validateToken.loading,
});

const mapDispatchToProps = {
  validateToken: validateTokenAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Home);
